import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { Field } from 'redux-form';
import { TextAreaField, TextField } from 'redux-form-antd';
import RangePicker from '../RangePicker';
import './LineItemAdd.css';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const LineItemAdd = ({ onCancel, visible, handleSubmit, submitting }) => (
  <Modal
    width={600}
    confirmLoading={submitting}
    onCancel={onCancel}
    onOk={handleSubmit}
    okText="Create"
    title="Create Line item"
    visible={visible}
  >
    <form onSubmit={handleSubmit} className="LineItemAdd">
      <Field {...formItemLayout} label="Name" name="name" component={TextField} />
      <RangePicker formItemLayout={formItemLayout} />
      <Field {...formItemLayout} label="Notes" name="description" component={TextAreaField} />
    </form>
  </Modal>
);

LineItemAdd.defaultProps = {
  submitting: false,
};

LineItemAdd.propTypes = {
  submitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default LineItemAdd;
